import React from "react"
import DeleteFilter from "../../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../../config/api";
import axios from "axios";

const postUrlLogin  = API_URL + "widgets";

class ByDate extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            status_widget : "inactive",
            current_key_time : {},
            result_rows : [],
            totals_widgets : { reservations_ly_by_widget : 0, reservations_by_widget : 0 },
            select_time_interval : 'hide-panel',
            reach_interval_time : '$month'
        }
        this.getDefaultValues = this.getDefaultValues.bind(this);
    }
    getDefaultValues(){
        return {
            status_widget: "inactive",
            current_key_time: {},
            result_rows: [],
            totals_widgets: { reservations_ly_by_widget: 0, reservations_by_widget: 0 },
            reach_interval_time : '$month'
        };
    }
    activeWdg(type){
        this.props.layout.activeWidget(type)
    }
    handleTimeFilter(filt, segments, key, key_string) {
        let $self               = this;
        let current_key_time    = this.state.current_key_time;
        let type                = this.props.app.state.view_results !== "trimester" ? true : false;
        switch (type) {
            case true:
                let not_exist = (current_key_time[filt] === undefined) ? true : false;
                if(not_exist === true){
                    current_key_time[filt] = key
                }else if(not_exist === false){
                    delete current_key_time[filt]
                }

                const status  =  (Object.keys(current_key_time).length > 0) ? "active" : "inactive";

                if(status === "inactive"){
                    segments = null;
                }
                this.setState({
                    current_key_time : current_key_time,
                    status_widget : status
                }, function(){
                    $self.props.layout.setSegments(segments, key, current_key_time);
                    $self.props.layout.activeFiltersMS(status);
                });
                break;
        
            case false:
                const status_trimester  =  (Object.keys(current_key_time).length > 0) ? "active" : "inactive";
                this.setState({ 
                    status_widget : status
                }, () => $self.props.layout.setTrimesters(status_trimester, key_string, key, filt))
                break;
        }
    }
    componentWillReceiveProps(props){
        let wdg     = props.layout.state.statics;
        this.state.result_rows = Object.keys(wdg).map((filt, index) => {
            
            let cssStyle;

            if(wdg[filt].num_reservations !== 0){
                if(props.layout._widgetSegment["major-segment-" + filt] !== undefined && props.layout._widgetSegment["major-segment-" + filt] !== null){
                    cssStyle = { height : (props.layout._widgetSegment["major-segment-" + filt].clientHeight) }
                }else{
                    cssStyle = wdg[filt].cssStyle;
                }

                const props_row = {
                    key : `list-bydate-${index}`,
                    className : `datagrid-item ${wdg[filt].state} ${(index%2 ? "row-c" : "")}`,
                    style : wdg[filt].state === "active" ? cssStyle : {}
                }
                const props_row_child = {
                    style : wdg[filt].state === "active" ? cssStyle : {}
                }
                const props_title = {
                    className : "title day", 
                    children : wdg[filt].string_value
                }
                const props_btn_more = {
                    onClick : this.handleTimeFilter.bind(this, filt, wdg[filt].segments, wdg[filt].key_value, wdg[filt].string_value),
                    className : `filter-row ${wdg[filt].state}`
                }
                
                
                return (
                    <div {...props_row}>
                        <div {...props_row_child}>
                            <span {...props_title}/>
                            {/*<span {...props_btn_more} />*/}
                        </div>
                    </div>
                )
            }
        })
    }

    setIntervalTimeView(event){
        this.setState({
            reach_interval_time : event.target.value,
        }, function(){
            let params = {
                reservations_module : {
                    reach_interval_time : this.state.reach_interval_time,
                    plan_interval_time : this.props.app.state.reservations_module.plan_interval_time
                }
            }
           this.props.layout.callMainRequest(params, false);
        })
    }

    render = () => {
        return(<div className={"datagrid-widget by-date-reach show-widget complete"}>
            <div className={"container-fluid "}>
                <div className="row header-widget">
                    <div className="col-md-12 options-widget">
                        <select className={"select-style"} onChange={this.setIntervalTimeView.bind(this)}>
                            <option selected={(this.state.reach_interval_time === '$month') ? true : false} value={'$month'}>MONTH</option>
                            <option selected={(this.state.reach_interval_time === '$week') ? true : false} value={'$week'}>WEEK</option>
                            <option selected={(this.state.reach_interval_time === '$dayOfWeek') ? true : false} value={'$dayOfWeek'}>DAY</option>
                        </select>
                    </div>
                </div>
                <div className="current-values">
                    <div className="row">
                        <div className="col-md-12 head-current">
                            <span children={this.props.app.state.current_year} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 datagrid-list">
                            {this.state.result_rows}
                            <div className={"datagrid-month totals"}>
                                <div>TOTAL</div>
                            </div>
                        </div>
                    </div>
                </div>   
            </div>
        </div>)
    }
};

export default ByDate;



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/views/Production/ByDate.js